import React, { useState, useEffect, useContext } from "react";
import { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "antd";
import JsqPay from "../components/JsqPay";
import HotList from "../components/HotList";
import LatestList from "../components/LatestList";
import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "./styles/scss/Store.scss";
import banner from "./styles/scss/img/store/banner-0.png";
import {
	CTX_STATE,
	CTX_DISPATCH,
	creator,
	Request,
	catchErrorHandle,
	platformObj,
	checkLogin,
	specialNavigate,
} from "../common";

export default function App() {
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);

	const [hotNav, setHotNav] = useState("Steam");
	const [hotList, setHotList] = useState([]);
	const [bannerList, setBannerList] = useState([]);
	const [newList, setNewList] = useState([]);
	const [jsqIsShow, setJsqIsShow] = useState(false);

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	useEffect(() => {
		const req = new Request({
			url: "/api/getProductList",
			data: {
				page: 1,
				pageSize: 20,
				platform: platformObj[hotNav],
				service: "group",
				sort: "hot",
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.status_code === 1000 && res.data?.data) {
					const list = res.data.data; //仅售卖支持共享账号游戏;

					!bannerList.length &&
						setBannerList([
							{
								pc_bg_img: banner,
								product_name: "购共享大会员，千款大作无限畅玩",
								group_vip_price: "限时折扣",
							},
							...list.slice(0, 6),
						]);

					setHotList(list);
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [hotNav, bannerList]);

	useEffect(() => {
		const req = new Request({
			url: "/api/getProductList",
			data: {
				page: 1,
				pageSize: 9,
				service: "group",
				sort: "new",
			},
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.status_code === 1000 && res.data?.data) {
					setNewList(res.data.data); //仅售卖支持共享账号游戏
				}
			} catch (error) {
				console.log(catchErrorHandle(error));
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, []);

	const buyMember = () => {
		checkLogin(_state, _dispatch, () => {
			_dispatch(creator("setMemberPayIsShow", true));
		});
	};

	const jsqPayClose = () => {
		setJsqIsShow(false);
	};

	const defaultConfig = (ele) => {
		if (ele === hotNav) return; //重复点击问题state不更新，但列表清空了，列表受单一选项影响的可以通用判断，有分页的需要区别排除分页变化

		setHotList([]); //处理接口延迟列表显示错误问题
	};

	return (
		<div className="main">
			<div className="store">
				<div className="banner">
					<div className="left">
						{bannerList.length ? (
							<Swiper
								modules={[Pagination, Autoplay]}
								slidesPerView={1}
								autoplay={true}
								pagination={{
									el: ".banner-pagination",
									type: "bullets",
									clickable: true,
									bulletClass: "btn",
									bulletActiveClass: "active",
									renderBullet: function (index, className) {
										return index === 0
											? `<button type="button" class="${className}"><div title="购大会员，千款游戏任你玩" style="max-width: 100%;">购大会员，千款游戏任你玩</div></button>`
											: `<button type="button" class="${className}"><div title="${bannerList[index]?.product_name}">${bannerList[index]?.product_name}</div><div>￥${hotList[index]?.group_vip_price}</div></button>`;
									},
								}}
							>
								{bannerList.map((ele, index) => {
									return (
										<SwiperSlide
											key={index}
											style={{ backgroundImage: `url(${ele.pc_bg_img})` }}
											onClick={() => {
												if (index === 0) {
													buyMember();
												} else {
													specialNavigate(
														"/Goods",
														_state.token,
														navigate,
														false,
														ele
													);
												}
											}}
										>
											<div className="title">
												<div className="price">
													{index !== 0 && "￥"}
													<span>{ele.group_vip_price}</span>
												</div>
												<div className="name">{ele.product_name}</div>
												{index === 0 ? (
													<div className="type activity">活动</div>
												) : (
													<div className="type share">共享账号</div>
												)}
											</div>
										</SwiperSlide>
									);
								})}
							</Swiper>
						) : (
							<Skeleton.Image active style={{ width: 740, height: 286 }} />
						)}

						<Skeleton
							active
							paragraph={{ rows: 8 }}
							loading={!bannerList.length}
							style={{ width: 680 }}
						>
							<div className="banner-pagination"></div>
						</Skeleton>
					</div>

					<div className={`right ${isNetbar ? `bar-right` : ``}`}>
						<button type="button" className="up"></button>
						<button
							type="button"
							className="down"
							onClick={() => {
								if (isNetbar) return;

								checkLogin(_state, _dispatch, () => {
									setJsqIsShow(true);
								});
							}}
						></button>
					</div>
				</div>

				<div className="hot">
					<div className="title">
						<div className="left">
							<div></div>畅销榜单
						</div>
						<div className="right">
							{Object.keys(platformObj)
								.slice(0, 4)
								.map((ele, index) => {
									return (
										<React.Fragment key={index}>
											<button
												type="button"
												className={hotNav === ele ? "active" : ""}
												onClick={() => {
													defaultConfig(ele);
													setHotNav(ele);
												}}
											>
												{ele}
											</button>
										</React.Fragment>
									);
								})}
						</div>
					</div>
					{hotList.length ? (
						<HotList list={hotList} />
					) : (
						<div className="content">
							{[...new Array(20)].map((ele, index) => {
								return <Skeleton.Avatar key={index} active shape="square" />;
							})}
						</div>
					)}
				</div>

				<div className="latest">
					<div className="title">
						<div className="left">
							<div></div>最新上架
						</div>
					</div>
					{newList.length ? (
						<LatestList list={newList} />
					) : (
						<Skeleton.Input active style={{ width: 1202, height: 152 }} />
					)}
				</div>
				<JsqPay isShow={jsqIsShow} onClose={jsqPayClose} />
			</div>
		</div>
	);
}
